import { Skeleton } from "@/components/ui/skeleton";

export default function LoaderInfoDoc() {
    return (
        <div className="w-full p-8 flex justify-start items-center gap-4 border rounded-lg">
            <Skeleton className="h-24 w-24 rounded-full" />

            {/* متن‌ها */}
            <div className="flex flex-col gap-2">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-4 w-48" />
                <Skeleton className="h-4 w-64 hidden md:block" />
                <Skeleton className="h-4 w-40 md:hidden" />
            </div>
        </div>
    );
}
